import {Injectable} from '@angular/core';
import {Observable, BehaviorSubject, Subject} from 'rxjs';
import {Tenant} from '../../models/tenant/tenant';
import {FabricService} from 'src/app/services/fabric/fabric.service';
import {tap} from 'rxjs/operators';

const SERVICE_NAME = 'mgmt-tenant-resources';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  private tenantSource = new BehaviorSubject<any>(null);
  tenant$ = this.tenantSource.asObservable();

  private _tenantData = new BehaviorSubject<any[]>([]);
  public readonly tenantData$: Observable<any[]> = this._tenantData.asObservable();
  private selectedTenantSubject = new BehaviorSubject<string>(null);
  selectedTenant$ = this.selectedTenantSubject.asObservable();
  
  constructor(private fabricService: FabricService) {

  }

  setTenantSource(tenant: any) {
    this.tenantSource.next(tenant);
  }

  getTenantSource() {
    return this.tenantSource.value;
  }

  getTenants(tenantId?, managementType?, regionPair?, cloudProvider?, temenosRegion?, targetCloud?, status?): Observable<Tenant[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants', {tenantId,
       managementType, temenosRegion, targetCloud, regionPair, cloudProvider, status})
      .pipe(tap(tenant => { 
        const tenantList = Array.isArray(tenant) ? tenant : [tenant];
        tenantList.forEach(this.convertModel);
        if (tenantId) {
          this._tenantData.next(tenant[0]?.cloudProvider? tenant[0]?.cloudProvider: tenant[0]?.targetCloud);
        }        
      }));
  }

  createTenant(tenant: Tenant): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_tenants', tenant);
  }

  updateTenant(tenant: Tenant): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_tenants_tenantid', tenant);
  }

  createTenantRegister(tenant: Tenant): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_tenant-register', tenant);
  }

  approveTenant(request: any): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post-tenant-mgmt-approve-tenants-tenant-id-approve', request);
  }

  getTenantDetails(tenantId): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid', {tenantId});
  }

  getTenantAccountDetails(tenantId): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_accounts', {tenantId});
  }

  postTenantAccountDetails(tenantId?, dataZone?): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_tenants_tenantid_accounts', {tenantId,dataZone});
  }

  getTenantClientDetails(tenantId): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_details', {tenantId});
  }

  postTenantSharedInfraDetails(infraDetails?): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_tenants_tenantid_shared-infra', infraDetails);
  }

  postTenantSharedServiceDetails(serviceDetails?): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_tenants_tenantid_shared-services', serviceDetails);
  }

  getTenantCertificate(tenantId): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_certs', {tenantId});
  }

  getTenantCertificateById(tenantId, Id): Observable<Tenant> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_certs_id', {tenantId, Id});
  }

  postTenantCertificate(tenantId, envType): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_tenants_tenantid_certs', {tenantId, envType});
  }

  putMessagingClientCert(tenantId, clientCertData, fileName, dataZone): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_tenants_tenantid_messaging_client-trust-cert', {tenantId, clientCertData, fileName, dataZone});
  }

  getMessagingClientCert(tenantId, dataZone): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_messaging_server-trust-cert', {tenantId, dataZone});
  }

  putDdosProtection(dataZone?: any): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_tenants_tenantid_ddos-protection', dataZone);
  }

  getDdosProtection(tenantId): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_tenants_tenantid_ddos-protection', {tenantId});
  }

  setTenant(tenantId: string) {
    this.selectedTenantSubject.next(tenantId);
  }


  convertModel(tenant: Tenant) {

  }

}

